import { transitionafyaImaraQuoteForm } from '../../../actions/afyaImara/quote';
import { getQuoteForm } from '../../../selectors/afyaImara/quote';

import { FIELD_STATUS } from '../../../reducers/status';

export const quoteFormRules = (store, next, action) => {
    const result = next(action);
    const quoteForm = getQuoteForm(store.getState());
    const quoteFormValid = validateQuoteForm(quoteForm);
    const formAction = quoteFormValid
        ? transitionafyaImaraQuoteForm.formValid()
        : transitionafyaImaraQuoteForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateQuoteForm = (formFields) => {
    const commonChecks =
        //formFields.dob.status === FIELD_STATUS.VALID &&
        formFields.inpatientCover.status === FIELD_STATUS.VALID;

    let spouseDetailsValid = true;

    if (formFields.spouseIncluded === 'yes') {
        spouseDetailsValid = formFields.spouseDob.status === FIELD_STATUS.VALID;
    }

    let childrenDobsValid = true;

    if (formFields.childrenIncluded === 'yes') {
        childrenDobsValid = formFields.childrenDobs.status === FIELD_STATUS.VALID;
    }

    const parityFieldsValid =
        formFields?.fullName?.status === FIELD_STATUS.VALID &&
        formFields?.email?.status === FIELD_STATUS.VALID &&
        formFields?.phoneNumber?.status === FIELD_STATUS.VALID;

    return commonChecks && spouseDetailsValid && childrenDobsValid && parityFieldsValid;
};
